import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIntegrations,
  fetchSharedIntegrations
} from "redux/actions/portal/integrationActionCreator";

export const useIntegrations = (shouldFetch = true) => {
  const { integrations, sharedIntegrations } = useSelector((store) => store?.portal?.integrations);
  const dispatch = useDispatch();
  const { user } = useAuth0();

  const handleFetchIntegrations = () => {
    dispatch(fetchIntegrations({ tenant_id: user.stripeId, user_id: user.cxfUserId }));
  };

  const handleFetchSharedIntegrations = () => {
    dispatch(fetchSharedIntegrations(user?.stripeId));
  };

  const determineShareStatus = (integration, sharedIntegrations) => {
    if (integration.create_user_id === user.cxfUserId) {
      return "Owner";
    } else if (
      sharedIntegrations
        ?.filter((i) => i.integration_id === integration.id)
        .some((i) => i.shared_user_id === user.cxfUserId)
    ) {
      return "Shared";
    } else {
      return "";
    }
  };

  const canEditIntegration = (integration) => {
    if (determineShareStatus(integration, sharedIntegrations) === "Shared") {
      return (
        sharedIntegrations?.find((i) => i.integration_id === integration.id)?.access_type ===
        "editor"
      );
    }

    if (determineShareStatus(integration, sharedIntegrations) === "Owner") {
      return true;
    }
  };

  useEffect(() => {
    if (!user?.stripeId || !user?.cxfUserId || !shouldFetch) return;

    if (integrations?.length) return;

    handleFetchIntegrations();
    handleFetchSharedIntegrations();
  }, [user?.stripeId, user?.cxfUserId, shouldFetch]);

  return {
    integrations: integrations ?? [],
    handleFetchIntegrations,
    determineShareStatus,
    sharedIntegrations,
    handleFetchSharedIntegrations,
    canEditIntegration
  };
};
